import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class AoiService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<Aoi[]> => {
    return this.apiHttp.get<Aoi[]>("aois");
  };
}

export interface Aoi {
  id: string;
  prismId: number;
  name: string;
  crop: string;
  cropId: number;
  isActive: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/aoi.service.ts